module.exports = __webpack_public_path__ + "static/media/10.75a2452d.png";